import PriceParity from '../src/PriceParity/index';
export default PriceParity;
